import AllRoute from "./routes/AllRoutes";

function App() {
  return (
    <>
      <AllRoute />
    </>
  );
}

export default App;
